import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { baseUrl } from "../../config/baseUrl";
import { toast, Bounce } from "react-toastify";
export default function JobScheduleForm() {
  let navigate = useNavigate();

  let [companyNameData, setCompanyNameData] = useState([]);
  const [formval, setFormval] = useState({
    assign_date: "",
    bus: "",
    company: "",
    cleaning_type: "",
    depo: "",
  });
  let [busData, setBusData] = useState([]);
  let [busDataFilter, setBusDataFilter] = useState([]);
  let [depotData, setDepotData] = useState([]); // Fix typo
  let [filteredBusData, setFilteredBusData] = useState([]); // Add filtered bus data state
  const [showDescriptionModal, setShowDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");
  const [pendingFormData, setPendingFormData] = useState(null);
  const [lastCleanedInfo, setLastCleanedInfo] = useState(null);

  let changeHandler = (e) => {
    setFormval((preVal) => ({ ...preVal, [e.target.name]: e.target.value }));
  };

  let depotChangeHandler = (e) => {
    const selectedDepot = e.target.value;
    setFormval((preVal) => ({ ...preVal, depo: selectedDepot, bus: "" })); // Reset bus when depot changes
    setFilteredBusData(
      busData.filter((bus) => bus.depo_name === selectedDepot)
    );
  };

  // let loginUser = JSON.parse(localStorage.getItem("user"));
  const companyName = async () => {
    let response = await axios(`${baseUrl}/module/admin/company-list`, {
      method: "GET",
      headers: {
        Authorization: "Token " + localStorage.getItem("token"),
      },
    });
    let allData = response.data?.data;
    // allData = allData?.filter((arr) => arr.id === loginUser?.company);
    setCompanyNameData(allData);
  };

  useEffect(() => {
    try {
      (async () => {
        let response = await axios(`${baseUrl}/module/admin/bus-list`, {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });
        setBusData(response?.data?.data);
        setBusDataFilter(response?.data?.data);
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
    try {
      (async () => {
        let response = await axios(`${baseUrl}/module/admin/depo-list`, {
          method: "GET",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
        });
        setDepotData(response?.data?.data);
      })();
    } catch (error) {
      console.error("Error :", error.response.data);
    }
    companyName();
  }, []);

  let handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !formval.assign_date ||
      !formval.bus ||
      !formval.company ||
      !formval.cleaning_type
    ) {
      return alert("all fileds is required");
    }
    try {
      const response = await axios(
        `${baseUrl}/module/admin/adminscheduler-viewset`,
        {
          method: "POST",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
          data: formval,
        }
      );

      if (response.data.code === 200) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/job-scheduled");
      } else if (response.data.code === 409) {
        setPendingFormData(formval);
        setLastCleanedInfo(response.data.data || null);
        setShowDescriptionModal(true);
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } else {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }

      // navigate("/BusList")
    } catch (error) {
      if (error.response?.data?.code === 409) {
        setPendingFormData(formval);
        setLastCleanedInfo(error.response?.data?.data || null);
        setShowDescriptionModal(true);
        toast.error(error.response?.data?.message || "Scheduler Type Already Exists ..!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      } else {
        console.error("Error :", error);
      }
    }
  };

  const handleDescriptionSubmit = async () => {
    if (!description.trim()) {
      alert("Description is required");
      return;
    }

    try {
      const payload = {
        ...pendingFormData,
        description: description,
      };

      const response = await axios(
        `${baseUrl}/module/admin/adminscheduler-viewset`,
        {
          method: "POST",
          headers: {
            Authorization: "Token " + localStorage.getItem("token"),
          },
          data: payload,
        }
      );

      if (response.data.code === 200) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        setShowDescriptionModal(false);
        setDescription("");
        setPendingFormData(null);
        setLastCleanedInfo(null);
        navigate("/job-scheduled");
      } else {
        toast.error(response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      console.error("Error :", error);
      toast.error(error.response?.data?.message || "Failed to submit. Please try again.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    }
  };

  const handleDescriptionCancel = () => {
    setShowDescriptionModal(false);
    setDescription("");
    setPendingFormData(null);
    setLastCleanedInfo(null);
  };
  let today = new Date().toISOString().split("T")[0];
  // const today = new Date().toISOString().split('T')[0];

  return (
    <>
      {/* <Header /> */}
      {/* <Sidebar /> */}
      <section className="main-sec">
        <div className="row">
          <div className="col-lg-12">
            <div className="dashboard-title">
              <h4 className="dash-head">
                <i className="fa fa-users me-2" />
                Add JobSchedule
              </h4>
            </div>
            <div className="custom-bredcump">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Add Job Schedule
                  </li>
                </ol>
              </nav>
            </div>
          </div>
          <div className="col-lg-12">
            <div className="cards edit-usr">
              <form action="" onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-4 mb-4">
                    <label htmlFor="" className="form-label">
                      Assign Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="assign_date"
                      min={today}
                      onChange={changeHandler}
                      defaultValue={formval?.assign_date}
                    />
                  </div>
                  <div className="col-lg-4 mb-4">
                    <label htmlFor="" className="form-label">
                      Depot Name
                    </label>
                    <select
                      onChange={depotChangeHandler}
                      name="depo"
                      className="form-select"
                    >
                      <option value="">Select Depot </option>
                      {depotData?.map((arr) => {
                        return (
                          <option key={arr?.id} value={arr?.depo_name}>
                            {arr?.depo_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <label htmlFor="" className="form-label">
                      Bus Name
                    </label>
                    <select
                      onChange={changeHandler}
                      name="bus"
                      className="form-select"
                    >
                      <option value="">Select Bus </option>
                      {filteredBusData?.map((arr) => (
                        <option key={arr?.id} value={arr?.id}>
                          {arr?.bus_number}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="col-lg-4 mb-4">
                    <label htmlFor="" className="form-label">
                      Cleaning Type
                    </label>
                    <select
                      onChange={changeHandler}
                      name="cleaning_type"
                      className="form-select"
                      value={formval?.cleaning_type}
                    >
                      <option>Select Cleaning Type</option>
                      <option value={"REGULAR_CLEANING"}>
                        REGULAR_CLEANING
                      </option>
                      <option value={"ANNUAL_DEEP_CLEANING"}>
                        ANNUAL_DEEP_CLEANING
                      </option>
                      <option value={"STANDARD_DEEP_CLEANING"}>
                        STANDARD_DEEP_CLEANING
                      </option>
                    </select>
                  </div>
                  <div className="col-lg-4 mb-4">
                    <label htmlFor="" className="form-label">
                      company
                    </label>
                    <select
                      name="company"
                      onChange={changeHandler}
                      value={companyNameData[0]?.arr}
                      className="form-select"
                    >
                      <option value="">Select company name</option>
                      {/* <option value="">-- Select Company --</option> */}
                      {companyNameData?.length > 0 &&
                        companyNameData.map((arr) => (
                          <option key={arr?.id} value={arr?.id}>
                            {arr?.company_name || "Unnamed Company"}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="col-lg-12 text-center">
                    <button type="Submit" className="thm-btn">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Description Modal */}
      {showDescriptionModal && (
        <div
          className="modal fade show"
          id="descriptionModal"
          tabIndex={-1}
          aria-labelledby="descriptionModalLabel"
          aria-hidden="false"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="descriptionModalLabel">
                  Add Description
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleDescriptionCancel}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                {lastCleanedInfo && (
                  <div className="alert alert-warning mb-3">
                    <strong>Previous Cleaning Record</strong>
                    {lastCleanedInfo.last_cleaned_date && (
                      <p className="mb-1">Last Cleaned: <strong>{lastCleanedInfo.last_cleaned_date}</strong></p>
                    )}
                    {lastCleanedInfo.last_scheduled_date && (
                      <p className="mb-0">Last Scheduled: <strong>{lastCleanedInfo.last_scheduled_date}</strong></p>
                    )}
                    {!lastCleanedInfo.last_cleaned_date && !lastCleanedInfo.last_scheduled_date && (
                      <p className="mb-0">No previous cleaning date found.</p>
                    )}
                  </div>
                )}
                <div className="mb-3">
                  <label htmlFor="descriptionTextarea" className="form-label">
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    id="descriptionTextarea"
                    rows="4"
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                    placeholder="Enter description..."
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={handleDescriptionCancel}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleDescriptionSubmit}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
